import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { supabase } from "../supabaseClient";

export default function Signup() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
  });
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (formData.password !== formData.confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    const { data, error } = await supabase.auth.signUp({
      email: formData.email,
      password: formData.password,
      options: {
        data: { full_name: formData.name },
      },
    });

    if (error) {
      setError(error.message);
    } else {
      console.log("Signup successful:", data.user);
      navigate("/login");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-white text-text-primary">
      <div className="flex flex-col md:flex-row w-full max-w-5xl rounded-2xl overflow-hidden shadow-2xl bg-bg-soft border border-border">

        {/* Left: Signup Form */}
        <div className="w-full md:w-1/2 p-10 md:p-12 bg-white">
          <h1 className="text-3xl font-extrabold mb-6 text-text-primary">Create Account</h1>
          <p className="mb-10 text-text-secondary">
            Join Vector Migration and start managing your vector DBs easily.
          </p>

          <form onSubmit={handleSubmit} className="space-y-5">
            {[
              { label: "Full Name", name: "name", type: "text", placeholder: "John Doe" },
              { label: "Email Address", name: "email", type: "email", placeholder: "name@email.com" },
              { label: "Password", name: "password", type: "password", placeholder: "••••••••" },
              { label: "Confirm Password", name: "confirmPassword", type: "password", placeholder: "••••••••" },
            ].map(({ label, name, type, placeholder }) => (
              <div key={name}>
                <label className="block mb-2 text-sm text-text-primary">{label}</label>
                <input
                  type={type}
                  name={name}
                  value={formData[name]}
                  onChange={handleChange}
                  placeholder={placeholder}
                  className="w-full px-4 py-3 rounded-md focus:outline-none focus:ring-2 focus:ring-accent bg-bg-soft border border-border text-text-primary placeholder:text-text-muted"
                  required
                />
              </div>
            ))}

            {error && (
              <p className="text-red-500 text-sm text-center">{error}</p>
            )}

            <button
              type="submit"
              className="w-full font-bold py-3 rounded-md transition bg-primary text-white hover:bg-primary-soft"
            >
              Sign Up
            </button>
          </form>

          <p className="text-center mt-8 text-sm text-text-secondary">
            Already have an account?{" "}
            <Link to="/login" className="font-semibold hover:underline text-text-primary hover:text-accent transition">
              Login
            </Link>
          </p>
        </div>

        {/* Right Section */}
        <div className="hidden md:flex w-1/2 relative items-center justify-center text-center p-10 bg-bg-soft">
          <div className="relative z-10 max-w-sm">
            <div className="flex justify-center mb-6">
              <div className="w-16 h-16 rounded-full flex items-center justify-center bg-primary">
                <span className="text-2xl font-bold text-white">V</span>
              </div>
            </div>
            <h2 className="text-2xl font-bold mb-4 text-text-primary">Welcome to Vector Migration</h2>
            <p className="leading-relaxed text-text-secondary">
              Start your journey with the most efficient tool for vector DB migration.
            </p>
            <div className="mt-8 rounded-xl p-4 text-sm bg-white border border-border text-text-secondary">
              <p>Join thousands of developers already transferring data across Qdrant, Pinecone, and ChromaDB effortlessly.</p>
              <div className="flex justify-center mt-4">
                <img src="https://i.pravatar.cc/100?img=5" alt="user" className="w-8 h-8 rounded-full -ml-2 border-2 border-border" />
                <img src="https://i.pravatar.cc/100?img=6" alt="user" className="w-8 h-8 rounded-full -ml-2 border-2 border-border" />
                <img src="https://i.pravatar.cc/100?img=7" alt="user" className="w-8 h-8 rounded-full -ml-2 border-2 border-border" />
                <img src="https://i.pravatar.cc/100?img=8" alt="user" className="w-8 h-8 rounded-full -ml-2 border-2 border-border" />
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}